import type { CarouselItem } from 'components/molecules/Carousel';
import React, { useCallback } from 'react';

import { StyledCol, StyledFullScreenPlayer, StyledImage } from './HomeCarousel.styles';

type CarouselItemType = 'video' | 'image';

const extRegExp = /(?:\.([^.]+))?$/;
const TypesMapper = new Map<string, CarouselItemType>([
  ['jpg', 'image'],
  ['png', 'image'],
  ['gif', 'image'],
  ['jpeg', 'image'],
  ['bmp', 'image'],
  ['webp', 'image'],
  ['mp4', 'video'],
  ['m4a', 'video'],
  ['fmp4', 'video'],
  ['mkv', 'video'],
  ['mp3', 'video'],
]);

interface Props {
  onPress?: () => void;
}

const FAQCard = ({ thumbnail, src, onPress }: CarouselItem & Props) => {
  const getFileType = useCallback((source: string) => {
    const extension = extRegExp.exec(source)?.[1] ?? '';
    return TypesMapper.get(extension);
  }, []);

  return (
    <StyledCol>
      {getFileType(src!!) === 'video' ? (
        <StyledFullScreenPlayer videoSrc={src} thumbnail={thumbnail} thumbnailWidth="140px" thumbnailHeight="160px" hidePlayButton />
      ) : (
        <StyledImage src={thumbnail} alt={`faq-image-${thumbnail}`} onClick={onPress} />
      )}
    </StyledCol>
  );
};

export default FAQCard;
